export type { BadgeProps } from './Badge'
export { Badge } from './Badge'
